import { render, staticRenderFns } from "./TildaForm.vue?vue&type=template&id=32ad910a&scoped=true"
import script from "./TildaForm.vue?vue&type=script&lang=js"
export * from "./TildaForm.vue?vue&type=script&lang=js"
import style0 from "./TildaForm.vue?vue&type=style&index=0&id=32ad910a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad910a",
  null
  
)

export default component.exports